import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../i18n";

type LanguageSwitcherProps = {
  className?: string;
};

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setLanguage(event.target.value);
  };

  return (
    <label className={className}>
      <span className="muted small">{t("language.label")}</span>
      <select value={i18n.language} onChange={handleChange}>
        <option value="en">{t("language.english")}</option>
        <option value="pt-BR">{t("language.portuguese")}</option>
        <option value="es">{t("language.spanish")}</option>
      </select>
    </label>
  );
}
